import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faPlus,
  faDownload,
  faExclamationTriangle,
  faCopy,
  faArrowLeft,
  faArrowRight,
  faBars,
  faExchangeAlt,
  faTimesCircle,
  faCircleNotch,
  faArrowDown,
  faCheck,
  faSync,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faPlus,
  faDownload,
  faExclamationTriangle,
  faCopy,
  faArrowLeft,
  faArrowRight,
  faBars,
  faExchangeAlt,
  faTimesCircle,
  faCircleNotch,
  faArrowDown,
  faCheck,
  faSync
);
